module.exports = __webpack_public_path__ + "static/media/new-course-Courses.f0ff7c41.jpg";